export default function Section({
  children,
  className = "",
  style = {},
  bcolor = "#022E57",
  forecolor = "#022E57",
  BG,
}) {
  return (
    <div
      className={`container-body ${className}`}
      style={{ backgroundColor: bcolor, ...style }}
    >
      {BG}
      <div className="container">{children}</div>
    </div>
  );
}
